<template>
  <div class="my-20">
    <div
      id="warp_map"
      ref="warp_map"
      style="height: calc(100vh - 9rem); z-index: 30"
    >
      <div id="map" ref="map" style="height: 100%; width: 100%"></div>
    </div>
    <div
      v-drag="{ handle: '#handle' }"
      style="left: 5%; top: 15%; position: absolute; z-index: 100"
    >
      <div
        style="
          height: 100%;
          min-width: 300px;
          width: 100%;
          border: 1px solid #fff;
        "
      >
        <div id="handle" class="dragger flex justify-between">
          <div class="mt-1">
            <feather-icon
              v-if="!isMinimize"
              icon="MinusIcon"
              class="cursor-pointer"
              @click="isMinimize = true"
            ></feather-icon>
            <feather-icon
              v-else
              icon="MaximizeIcon"
              class="cursor-pointer"
              @click="isMinimize = false"
            ></feather-icon>
          </div>
        </div>
        <div
          style="
            background-color: white;
            padding-left: 8px;
            padding-right: 8px;
            padding-bottom: 4px;
          "
        >
          <div v-if="!isMinimize">
            <div>
              <b>{{ vessel.name || "-" }} ({{ vessel.mmsi || "-" }})</b>
              <p>MMSI: {{ vessel.mmsi || "-" }}</p>
              <p>name: {{ vessel.name || "-" }}</p>
            </div>
            <v-date-picker
              :masks="masks"
              :locale="$i18n.locale"
              :buddhist="true"
              :max-date="new Date()"
              :popover="{ placement: 'auto', visibility: 'click' }"
              v-model="selectedDate"
              mode="dateTime"
              is-range
              is24hr
            >
              <template v-slot="{ inputEvents }">
                <vs-input
                  :value="`${formateDate(
                    selectedDate.start,
                    'start'
                  )} - ${formateDate(selectedDate.end, 'end')}`"
                  label="วันที่"
                  class="w-full"
                  placeholder="วัน/เดือน/ปี - วัน/เดือน/ปี"
                  v-on="inputEvents.start"
                />
              </template>
            </v-date-picker>
            <div class="vx-col w-4/5 pr-2 pl-0">
              <form autocomplete="off" class="w-full">
                <vs-select
                  v-model="selectTimeInterval"
                  class="w-full select-large"
                  label="ความละเอียดข้อมูล"
                  autocomplete
                >
                  <vs-select-item
                    v-for="(item, index) in interval"
                    :key="index"
                    :value="item.time"
                    :text="item.name"
                    class="w-full"
                  />
                </vs-select>
              </form>
            </div>
            <vs-divider class="mb-0"></vs-divider>
            <div class="flex">
              <div class="vx-col w-4/5 pr-2 pl-0">
                <div style="padding:4px">compare mmsi</div>
                <vs-input v-model="mmsiCompare" class="w-full"/>
              </div>
              <div class="vx-col w-1/5 mt-6 pr-4 pl-0" vs-align="left" style="padding:4px">
                <vs-button
                  style="margin-top:4px"
                  color="primary"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-search"
                  class="w-full"
                  @click="search()"
                >
                </vs-button>
              </div>
            </div>
          </div>
          <div v-if="isMinimize || positionReports.length > 1">
            <div
              v-if="positionReports && positionReports.length > 1"
              style="padding: 8px; width: 100%"
            >
              <vs-slider
                :min="1"
                :max="positionReports.length"
                :disabled="positionReports.length ? false : true"
                v-model="value"
                class="w-1/2"
                color="warning"
                @change="onChange"
              />
            </div>
            <div
              v-if="positionReports && positionReports.length > 1"
              class="vx-row p-2 flex justify-center"
            >
              <div class="mx-1">
                <vs-button
                  v-if="!playing"
                  color="primary"
                  type="filled"
                  icon="play_arrow"
                  @click="onPlay"
                ></vs-button>
                <vs-button
                  v-else
                  color="primary"
                  type="filled"
                  icon="pause"
                  @click="onPause"
                ></vs-button>
              </div>
              <div class="mx-1">
                <vs-button
                  color="danger"
                  type="filled"
                  icon="stop"
                  @click="onStop"
                ></vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { VueContext } from "vue-context";
import gmapsInit from "@/gmap/gmaps";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import moment from "moment-timezone";
import { mapState } from "vuex";
import WindowHistoryVessel from "../components/map/WindowHistoryVessel.vue";
import Swal from 'sweetalert2'

export default {
  name: "CompareVessel",
  components: {
    VueContext,
    Datepicker,
    vSelect,
    WindowHistoryVessel,
  },
  data() {
    return {
      mmsiCompare: "",
      vessel: {},
      selectedDate: {
        start: new Date(),
        end: new Date(),
      },
      selectTimeInterval: 86400,
      interval: [
        {
          id: 1,
          name: "1 minute",
          time: 60,
        },
        {
          id: 2,
          name: "5 minutes",
          time: 300,
        },
        {
          id: 3,
          name: "10 minutes",
          time: 600,
        },
        {
          id: 4,
          name: "15 minutes",
          time: 900,
        },
        {
          id: 5,
          name: "30 minutes",
          time: 1800,
        },
        {
          id: 6,
          name: "1 hour",
          time: 3600,
        },
        {
          id: 7,
          name: "2 hours",
          time: 7200,
        },
        {
          id: 8,
          name: "4 hours",
          time: 14400,
        },
        {
          id: 9,
          name: "6 hours",
          time: 21600,
        },
        {
          id: 10,
          name: "12 hours",
          time: 43200,
        },
        {
          id: 11,
          name: "1 day",
          time: 86400,
        },
        {
          id: 12,
          name: "2 days",
          time: 172800,
        },
      ],
      masks: {
        title: "MMMM YYYY",
        weekdays: "W",
        navMonths: "MMM",
        input: ["L", "YYYY-MM-DD", "YYYY/MM/DD"],
        dayPopover: "WWW, MMM D, YYYY",
        data: ["L", "YYYY-MM-DD", "YYYY/MM/DD"],
      },
      positionCompare: [],
      detailCompare: [],
      positionReports: [],
      positions1: [],
      positions2: [],
      value: 1,
      isMinimize: false,
      // map
      google: null,
      map: null,
      geocoder: null,
      warpMap: null,
      polyline1: null,
      polyline2: null,
      dotMarket: [],
      markers: [],
      markers1: [],
      markers2: [],
      vessel1: {},
      vessel2: {},
      playing: false,
      tickerTimer: null,
      infoWindow: null
    };
  },
  computed: mapState({
    compare: (state) => ({
      positionCompareReports: state.rts.positionCompareReports,
      detailCompareHistory: state.rts.detailCompareHistory,
    }),
  }),
  watch: {
    compare(val) {
      if (!_.isEmpty(val)) {
        const position1 = val.positionCompareReports[0] || [];
        const position2 = val.positionCompareReports[1] || [];
        if (
          val.positionCompareReports.length &&
          val.detailCompareHistory.length
        ) {
          this.positionReports =
            position1.length >= position2.length ? position1 : position2;
          this.positions1 = position1;
          this.positions2 = position2;
          this.renderVesselPositionHistory(
            val.positionCompareReports,
            val.detailCompareHistory
          );
        }
      }
    },
  },
  created() {
    this.$vs.loading();
    this.initMap();
    this.init();
  },
  methods: {
    init() {
      if (localStorage) {
        this.vessel = JSON.parse(
          _.get(localStorage, "compareVessel", JSON.stringify({}))
        );
      }
      window.onbeforeunload = () => {
        return "Are you sure you want to close the window?";
      };
      window.addEventListener("beforeunload", () =>
        localStorage.removeItem("compareVessel")
      );
    },
    async initMap() {
      for (let i = 1; i <= 2; i++) {
        this.google = await gmapsInit();
        this.geocoder = new google.maps.Geocoder();
        const options = {
          zoom: 7,
          center: { lat: 10.18383, lng: 100.60639 },
          streetViewControl: false,
          mapTypeControl: false,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          fullscreenControl: true,
          gestureHandling: "greedy",
          zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_CENTER,
          },
        };
        const map = new google.maps.Map(
          this.$el.querySelector("#map"),
          options
        );
        this.warpMap = this.$el.querySelector("#warp_map");
        map.data.setStyle((feature) => {
          var color = feature.getProperty("color");
          if (color == "red") {
            color = "red";
          } else if (color == "green") {
            color = "#10FD1E";
          } else if (color == "blue") {
            color = "#00BDFF"; //#E7E9EB
          } else if (color == "darkBlue") {
            color = "#0083FF";
          } else if (color == "blue3") {
            color = "#006EFF";
          } else if (color == "blue4") {
            color = "#0048FF"; //'#0048FF'
          } else if (color == "blue5") {
            color = "#0022FF"; //'#0022FF'
          }
          var stroke = feature.getProperty("name") == "line" ? 1 : 0;
          return {
            clickable: false,
            fillColor: color,
            strokeWeight: stroke,
            strokeColor: color == "gray" ? "#57A8EC" : false,
          };
        });
        this.map = map;
        this.infoWindow = new google.maps.InfoWindow();
      }
      this.$vs.loading.close();
    },
    formateDate(date, type) {
      if (type == "start") {
        return (
          date &&
          moment(date)
            // .set({ hour: 0, minute: 0 })
            .add(543, "year")
            .format("DD/MM/YYYY HH:mm")
        );
      } else {
        return date && moment(date).add(543, "year").format("DD/MM/YYYY HH:mm");
      }
    },
    async search() {
      if (this.mmsiCompare) {
        this.clearAll();
        const searchData = [];
        const data = {
          date: {
            start: moment(this.selectedDate.start)
              // .set({'hour': 0, 'minute': 0})
              .tz("Asia/Bangkok")
              .format("DD/MM/YYYY HH:mm:ss"),
            end: moment(this.selectedDate.end)
              .add(1, "day")
              .tz("Asia/Bangkok")
              .format("DD/MM/YYYY HH:mm:ss"),
          },
          mmsi: this.vessel.mmsi,
          interval: this.selectTimeInterval,
        };
        searchData.push(data);
        const data2 = { ...data };
        data2.mmsi = this.mmsiCompare;
        searchData.push(data2);
        await this.$store.dispatch("rts/getVesselCompareHistories", searchData);
      } else {
        // alert("please input compare data");
        Swal.fire({
          icon: 'warning',
          title: 'เกิดข้อผิดพลาด',
          text: 'กรุณากรอก MMSI ที่ต้องการเปรียบเทียบข้อมูล',
          showConfirmButton: false,
        })
      }
    },
    renderVesselPositionHistory(vesselPosition = [], vesselDetails = []) {
      const vesselPosition1 = vesselPosition[0] || [];
      const vesselPosition2 = vesselPosition[1] || [];

      console.log("vesselPosition ", vesselPosition);
      console.log("vesselDetails ", vesselDetails);

      const vesselDetail1 = vesselDetails[0];
      const vesselDetail2 = vesselDetails[1];

      if (vesselPosition1.length) {
        const posData1 = {
          id: "-",
          ...vesselPosition1[0],
        };
        this.vessel1 = vesselDetail1;
        this.drawPosition(vesselPosition1, this.map, 1);
        this.drawVesselHistory(
          vesselDetail1,
          posData1,
          this.map,
          this.markers1
        );
      }

      if (vesselPosition2.length) {
        const posData2 = {
          id: "-",
          ...vesselPosition2[0],
        };
        this.vessel2 = vesselDetail2;
        this.drawPosition(vesselPosition2, this.map, 2);
        this.drawVesselHistory(
          vesselDetail2,
          posData2,
          this.map,
          this.markers2
        );
      }
    },
    drawVesselHistory(vessel, data, map, markers) {
      const { latitude, longitude } = data;
      const vesselData = Array.isArray(vessel) ? vessel[0] : vessel;
      const tanker = {
        ...vesselData,
        ...data,
        hdg_cog: data.true_heading,
      };
      const position = new google.maps.LatLng(latitude, longitude);
      const img = this.getVesselImg(tanker);
      const markerImage = this.createMarkerIcon(img, 30);
      const marker = new google.maps.Marker({
        position,
        map,
        icon: markerImage,
        zIndex: 999,
      });
      markers.push(marker);

      const mmsi = tanker.mmsi;
      const mid = tanker.name;
      const lat = tanker.latitude;
      const lng = tanker.longitude;
      const speed = tanker.speed_over_ground;
      const hdg_cog = tanker.true_heading || tanker.hdg_cog;
      let record_time = tanker.record_time;

      let infoHtml = `<div class="info">`;
      infoHtml += mmsi ? `<p>MMSI: ${mmsi}</p>` : "";
      infoHtml += mmsi ? `<p>name: ${mid}</p>` : "";
      infoHtml += `<p>latitude: ${lat}</p>`;
      infoHtml += `<p>longitude: ${lng}</p>`;
      infoHtml += mmsi ? `<p>true heading: ${hdg_cog}</p>` : "";
      infoHtml += mmsi ? `<p>speed over ground: ${speed}</p>` : "";
      infoHtml += record_time ? `<p>record time: ${record_time}</p>` : "";
      infoHtml += `</div>`;

      const infowindow = new google.maps.InfoWindow({
        content: infoHtml,
        maxWidth: 250,
      });

      infowindow.open({
        anchor: marker,
        map: map,
        shouldFocus: false,
      });
      infowindow.setPosition(position);

      // const fn1 = this.markerClickFunction1(tanker, position);
      // const fn2 = this.markerClickFunction2(tanker, position);
      // const fn3 = this.markerClickFunction3(tanker, position);
      // google.maps.event.addListener(marker, "mouseover", fn1);
      // google.maps.event.addListener(marker, "click", fn2);
      // google.maps.event.addListener(marker, "mouseout", fn3);
    },
    drawPosition(positions = [], myMap, vesselNumber = 0) {
      const coords = [];
      for (let i = 0; i < positions.length; i++) {
        let filename = "dot";
        if (i == 0) {
          filename = "dot_green";
        } else if (i == positions.length - 1) {
          filename = "dot_red";
        }
        let icon = "";
        if (
          process.env.NODE_ENV == "production" ||
          process.env.NODE_ENV == "staging"
        ) {
          icon = this.createMarkerIcon(
            `/admin/assets/vesselIcon/icons/${filename}.png`,
            8
          );
        } else {
          icon = this.createMarkerIcon(
            `/assets/vesselIcon/icons/${filename}.png`,
            8
          );
        }
        const position = this.drawMakerDotPoint(positions[i], icon, myMap);
        coords.push(position);
      }
      this.drawLine(coords, myMap, vesselNumber);
    },
    drawMakerDotPoint(data, markerImage, myMap) {
      const position = new google.maps.LatLng(data.latitude, data.longitude);
      const dotMarket = new google.maps.Marker({
        position,
        map: myMap,
        icon: markerImage,
      });
      const fn1 = this.markerClickFunction1(data, position);
      const fn3 = this.markerClickFunction3(data, position);
      google.maps.event.addListener(dotMarket, "mouseover", fn1);
      google.maps.event.addListener(dotMarket, "mouseout", fn3);
      this.dotMarket.push(dotMarket);
      return position;
    },
    markerClickFunction1(vessel, latlng) {
      return (e) => {
        e.cancelBubble = true;
        e.returnValue = false;
        if (e.stopPropagation) {
          e.stopPropagation();
          e.preventDefault();
        }
        const oldVessel = { ...this.selectedVessel };
        this.selectedVessel = vessel;
        const id = vessel.id;
        const mmsi = vessel.mmsi;
        const mid = vessel.name;
        const lat = vessel.latitude;
        const lng = vessel.longitude;
        const speed = vessel.speed_over_ground;
        const hdg_cog = vessel.true_heading || vessel.hdg_cog;
        let record_time = vessel.record_time;
        // if (vessel.record_time) {
        //   record_time = `${this.setDateFormatRecordTime(vessel.record_time)}`;
        // }

        let infoHtml = `<div class="info">`;
        infoHtml += mmsi ? `<p>MMSI: ${mmsi}</p>` : "";
        infoHtml += mmsi ? `<p>name: ${mid}</p>` : "";
        infoHtml += `<p>latitude: ${lat}</p>`;
        infoHtml += `<p>longitude: ${lng}</p>`;
        infoHtml += mmsi ? `<p>true heading: ${hdg_cog}</p>` : "";
        infoHtml += mmsi ? `<p>speed over ground: ${speed}</p>` : "";
        infoHtml += record_time ? `<p>record time: ${record_time}</p>` : "";
        infoHtml += mmsi
          ? `<br/><p><a href="#" id="history">History</a> | `
          : "";
        infoHtml += mmsi
          ? `<a href="#" id="compare">Compare</a> | `
          : "";
        infoHtml += mmsi
          ? `<a href='#' id="oilTransfer">Oil Transfer</a> | `
          : "";
        infoHtml += mmsi ? `<a href='#' id="vesselInfo">Info</a></p>` : "";
        infoHtml += `</div>`;

        $(document).ready(() => {
          $("#history").click(() => {
            this.isActiveHistory(vessel);
          });

          $("#compare").click(() => {
            this.compare(vessel);
          });

          $("#oilTransfer").click(async () => {
            // console.log(oldVessel.id, this.selectedVessel.id);
            // if (oldVessel.id != this.selectedVessel.id) {
              console.log("reset");
              this.totalExpenses = 0;
              this.totalReceiving = 0;
              this.totalOilVolume = 0;
              this.selectedDate = {
                start: new Date(),
                end: new Date(),
              },

              this.oilTransfers = [];
              this.clearLineMarker();
              this.clearMarkers();
              this.showMarkers();
              await this.$store.dispatch("oilTransfer/resetOilTransfer");
            // }

            this.popUpOilTransferActivate = true;
            if (
              vessel.icon_type == "EXCISE" ||
              vessel.icon_type == "other" ||
              vessel.icon_type == "tanker"
            ) {
              let searchTanker = this.optionsTanker.find(
                (t) => t.mmsi == vessel.mmsi
              );
              if (!searchTanker) {
                searchTanker = this.optionsTanker.find(
                  (t) => t.nameEng == vessel.name
                );
              }
              this.targetVessel = null
              this.targetTanker = searchTanker;
            } else if (
              vessel.icon_type == "cargo" ||
              vessel.icon_type == "passenger" ||
              vessel.icon_type == "fishing"
            ) {

              // console.log('optionsVessel = ', this.optionsVessel)
              await this.$store.dispatch('mpTankerData/getMpVesselByMMSI', vessel.mmsi)
              console.log('vessels change >>> ', vessel.mmsi, this.mpVesselByMMSI)
              //  let searchVessel = this.optionsVessel.find((v) => v.mmsi == vessel.mmsi)
              //  console.log('f = ', searchVessel)
              //  if (!searchVessel) {
              //   searchVessel = this.optionsVessel.find((v) => v.nameEng == vessel.name)
              //  }
              this.targetTanker = null
              this.targetVessel = this.mpVesselByMMSI
            }
          });

          $("#vesselInfo").click(() => {
            this.isVesselInfo(vessel);
          });
        });

        this.infoWindow.setContent(infoHtml);
        this.infoWindow.setPosition(latlng);
        this.infoWindow.open(this.map);
      };
    },
    markerClickFunction3(vessel, latLng) {
      return (e) => {
        e.cancelBubble = true;
        e.returnValue = false;
        if (e.stopPropagation) {
          e.stopPropagation();
          e.preventDefault();
        }
        this.infoWindow.close();
      };
    },
    drawLine(coords, myMap, vesselNumber) {
      this["polyline" + vesselNumber] = new google.maps.Polyline({
        path: coords,
        geodesic: true,
        strokeColor: vesselNumber == 1 ? "#0000ff" : "#000000",
        strokeOpacity: 1.0,
        strokeWeight: 3,
        icons: [
          {
            icon: {
              path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
              strokeColor: "#F00",
              fillColor: "#F00",
              fillOpacity: 1,
              strokeWeight: 1,
            },
            repeat: "50px",
          },
        ],
      });
      this["polyline" + vesselNumber].setMap(myMap);
    },
    createMarkerIcon(imageUrl, imgSize) {
      const size = imgSize || 30;
      var markerImage = new google.maps.MarkerImage(
        imageUrl,
        new google.maps.Size(size, size),
        new google.maps.Point(0, 0),
        new google.maps.Point(size / 2, size / 2),
        new google.maps.Size(size, size)
      );
      return markerImage;
    },
    getVesselImg(vessel) {
      const direction = vessel.hdg_cog || 360;
      let iconType = vessel.icon_type;
      const shipType = vessel.navigation_status_code == "0" ? "b" : "";
      let imgShip = "other";
      if (iconType == "tanker") {
        imgShip = "tanker";
      } else if (iconType == "other") {
        imgShip = "other";
      } else if (iconType == "passenger") {
        imgShip = "passenger";
      } else if (iconType == "cargo") {
        imgShip = "cargo";
      } else if (iconType == "fishing" || vessel.ship_type.id == 31) {
        imgShip = "fishing";
      } else if (iconType == "EXCISE" || vessel.ship_type.id == 81) {
        imgShip = "excise";
      }
      let imageUrl = "";
      if (
        process.env.NODE_ENV == "production" ||
        process.env.NODE_ENV == "staging"
      ) {
        imageUrl = `/admin/assets/vesselIcon/${imgShip}/${shipType}${this.getDirection(
          direction
        )}.png`;
      } else {
        imageUrl = `/assets/vesselIcon/${imgShip}/${shipType}${this.getDirection(
          direction
        )}.png`;
      }
      return imageUrl;
    },
    getDirection(direction) {
      const n = direction % 10 ? 0 : 1;
      const tpye = Math.ceil(direction / 10) + n;
      return tpye > 36 ? 10 : tpye;
    },
    onChange(value) {
      if (this.positions1.length) {
        const p1 = this.positions1[value - 1];
        if (!_.isEmpty(p1)) {
          this.clearMarkers(this.markers1);
          this.drawVesselHistory(this.vessel1, p1, this.map, this.markers1);
        }
      }
      if (this.positions2.length) {
        const p2 = this.positions2[value - 1];
        if (!_.isEmpty(p2)) {
          this.clearMarkers(this.markers2);
          this.drawVesselHistory(this.vessel2, p2, this.map, this.markers2);
        }
      }
    },
    clearMarkers(markers) {
      for (let i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
      }
    },
    clearAll() {
      this.clearMarkers(this.markers1);
      this.markers1 = [];
      this.clearMarkers(this.markers2);
      this.markers2 = [];

      for (let i = 1; i <= 2; i++) {
        if (this["polyline" + i]) {
          this["polyline" + i].setMap(null);
          this["polyline" + i] = null;
        }
      }
      if (this.dotMarket.length) {
        for (let i = 0; i < this.dotMarket.length; i++) {
          this.dotMarket[i].setMap(null);
        }
        this.dotMarket = [];
      }
    },
    onPlay() {
      if (!this.tickerTimer) {
        if (this.value == this.positionReports.length) {
          this.value = 1;
        }
        this.playing = true;
        this.onTickerTimer();
      }
    },
    onStop() {
      this.clearTickerTimer(true);
    },
    onPause() {
      this.clearTickerTimer(false);
    },
    clearTickerTimer(isStop) {
      clearTimeout(this.tickerTimer);
      this.tickerTimer = null;
      this.playing = false;
      if (isStop == true) {
        this.value = 1;
      }
    },
    onTickerTimer() {
      this.tickerTimer = setTimeout(() => {
        this.onTickerTimer();
        if (this.value + 1 <= this.positionReports.length) {
          this.value += 1;
        } else if (this.value + 1 > this.positionReports.length) {
          this.clearTickerTimer(false);
        }
        this.vessel;
      }, 1200);
    },
  },
};
</script>

<style lang="scss">
.dragger::before {
  content: "Compare";
}
</style>